module.exports = __webpack_public_path__ + "img/icon54.7c23d120.png";